export const DOCUMENTS_TABLE_HEADER = [
  {
    displayName: 'Megnevezés',
    ref: 'displayName',
  },
  {
    displayName: 'Műveletek',
    ref: 'operations',
  },
];

export const DOCUMENTS_TABLE_HEADER_IN_MOBILE = [
  {
    displayName: 'Megnevezés',
    ref: 'displayName',
  },
  {
    displayName: 'Műveletek',
    ref: 'operations',
  },
];
